import axios from "@/plugins/axios"
import axiosOriginal from "@/plugins/axiosUninterseptor"
import qs from "qs"

export const getAllCities = async (sortType = "asc") => {
  const query = qs.stringify(
    {
      sort: [`name:${sortType}`],
      populate: {
        localizations: "*",
      },
    },
    {
      encodeValuesOnly: true,
    },
  )
  const response = await axios.get(`/cities?${query}`)
  return response?.data?.data
}

export const getShopsByCityId = async (id, sortType = "asc") => {
  const query = qs.stringify(
    {
      populate: {
        shops: {
          sort: [`publishedAt:${sortType}`],
          populate: {
            shop_type: {
              populate: ["logo"],
            },
            shop_features: {
              populate: "*",
            },
          },
        },
        localizations: "*",
      },
    },
    {
      encodeValuesOnly: true,
    },
  )
  const response = await axios.get(`/cities/${id}?${query}`)
  return response?.data.data?.attributes?.shops?.data
}

export const getBanners = async (cityId, type) => {
  if (!cityId) {
    cityId =
      localStorage.getItem("selectCity") !== undefined
        ? JSON.parse(localStorage.getItem("selectCity"))?.id
        : 2
  }
  const query = qs.stringify({
    populate: "*",
    sort: ["order:asc"],
    filters: {
      cities: {
        id: { $eq: cityId },
      },
      type: {
        $contains: type,
      },
    },
  })
  const response = await axios.get(`/banners?${query}`)
  return response?.data?.data
}
export const getPromos = async (stock, pagination, excludeStockId) => {
  let date = new Date().toLocaleDateString("ru", { day: "2-digit" })
  let month = new Date().toLocaleDateString("ru", { month: "2-digit" })
  let year = new Date().toLocaleDateString("ru", { year: "numeric" })
  const selectedCityId = localStorage.getItem("selectCity")
    ? JSON.parse(localStorage.getItem("selectCity"))?.id
    : 2
  const today = `${year}-${month}-${date}`

  let filters = {}
  if (stock?.type === "current") {
    filters = {
      $or: [
        {
          $and: [{ date_end: { $gte: today } }, { date_start: { $lte: today } }],
        },
        { date_end: { $null: true }, date_start: { $null: true } },
      ],
    }
  }

  if (stock?.type === "announcement") {
    filters["date_start"] = { $gt: today }
  }

  if (stock?.type === "completed") {
    filters["date_end"] = { $lt: today }
  }
  if (excludeStockId) {
    filters["id"] = { $ne: excludeStockId }
  }
  const query = qs.stringify(
    {
      pagination: {
        page: pagination?.page || 1,
        pageSize: pagination?.pageSize || 500,
      },
      populate: {
        preview_desktop: "*",
        preview_mob: "*",
        discount: "*",
        shops: {
          populate: "*",
        },
        localizations: {
          populate: {
            discount: "*",
            preview_desktop: "*",
            preview_mob: "*",
          },
        },
      },
      sort: ["order:asc"],
      filters: { ...filters, cities: { id: { $eq: selectedCityId } } },
    },
    {
      encodeValuesOnly: true,
    },
  )
  const response = await axios.get(`/promos?${query}`)
  return response?.data
}

export const getPromo = async (id) => {
  const query = qs.stringify(
    {
      populate: {
        backgound_desktop: "*",
        backgound_mob: "*",
        discount: {
          populate: {
            products: {
              populate: "*",
            },
          },
        },
        localizations: {
          populate: {
            backgound_desktop: "*",
            backgound_mob: "*",
          },
        },
      },
    },
    {
      encodeValuesOnly: true,
    },
  )
  const response = await axios.get(`/promos/${id}?${query}`)
  return response?.data
}

export const getIIN = async (IIN) => {
  const response = await axiosOriginal.get(`/gsp/info?iin=${IIN}`)
  return response?.data
}

export const getRules = async () => {
  const query = qs.stringify()
  const response = await axios.get(`/rule?${query}`)
  return response?.data?.data
}
